/**
 * Commerce7 Collection Filter - clear filter handle
 */
import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
    const selectors = {
        quickView: ".c7-show-modal",
        closePopup: ".c7-product-popup-close",
        purchase: ".c7-product-purchase-btn",
        loadmore: ".wine-load-more",
        count: ".show-counts",
        total: ".total-counts",
        loading: ".load-more-waiting",
    };

    this.init = () => {
        c7.addAction("c7_collection_products_rendered", (collection) => {
            // Do something after collection rendered.
            registerEventHandlers();
            renderVivinoScore(collection);
            renderedCollection();
            removePriceDot();
        });
    };
    const removePriceDot = () => {
        jQuery(
            ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
        ).each(function (i, e) {
            let text = jQuery(e).text();
            jQuery(e).text(
                text.replace(".00", "").replace("Was", "").replace("Now", "")
            );
        });
    };

    const registerEventHandlers = () => {
        jQuery(document).on("click", selectors.quickView, function () {
            getProductInfo(jQuery(this));
        });
        jQuery(document).on("click", selectors.closePopup, function () {
            closePopup();
        });
        jQuery(document).on("click", selectors.purchase, function () {
            addToCart(jQuery(this));
        });
        jQuery(document).on("click", selectors.loadmore, function () {
            loadMoreWines();
        });
    };

    const renderedCollection = () => {
        activeFilter()
        jQuery(".c7-product-collection .loader").hide();
        loadMoreWines();
        setTimeout(() => {
            loadCallout();
        }, 1000);
    };
    const activeFilter = () => {
        // const selectors = {
        //     src: ".accordion-src",
        //     dist: ".accordion-dist",
        //     accordions: ".accordions",
        //     accordion: ".single-accordion",
        // };
        // if (jQuery(selectors.accordion).length) {
        //     jQuery(selectors.accordion).each(function () {
        //         const el = jQuery(this);
        //         el.find(selectors.dist).slideUp(400);
        //     })
        // }
        jQuery(".filter-item--content li a.active").closest(".filter-item--content").prev().addClass('open')
        jQuery(".filter-item--content li a.active").closest(".filter-item--content").show()
    }

    const controlLoading = (status) => {
        if ("open" === status) {
            document.querySelector(selectors.loading).classList.add("loading");
            jQuery(".load-more-waiting .loader").show();
        } else {
            document.querySelector(selectors.loading).classList.remove("loading");
            jQuery(".load-more-waiting .loader").hide();
        }
    };
    const getProductInfo = (element) => {
        const slug = jQuery(element).data("slug");
        jQuery.ajax({
            type: "GET",
            url: theme_object.ajax_url,
            data: { action: "get_product_details", slug },
            beforeSend: function () {
                controlLoading("open");
            },
            success: function (response) {
                controlLoading("close");
                if (response["success"]) {
                    jQuery("body").append(response["html"]);
                    if (jQuery(".owl-carousel").length) {
                        jQuery(".owl-carousel").owlCarousel({
                            autoplay: true,
                            autoplayTimeout: 7000,
                            dots: true,
                            items: 1,
                            loop: true,
                            nav: false,
                            smartSpeed: 400,
                        });
                        jQuery(".c7-product-popup .c7-product-popup-images").click(
                            function () {
                                jQuery(".c7-product-popup-images.owl-carousel").trigger(
                                    "next.owl.carousel"
                                );
                            }
                        );
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    };

    const closePopup = () => {
        jQuery(".c7-product-popup").remove();
    };

    const addToCart = (element) => {
        const inputId = jQuery(element).data("target");
        const inputElem = jQuery(`#${inputId}`);
        const quantity = jQuery(element)
            .parents(".c7-product-purchase")
            .find(".c7-product-purchase-quantity")
            .val();
        jQuery(inputElem).val(quantity);
        jQuery(inputElem)
            .parents(".c7-product__add-to-cart__form")
            .find(".c7-btn")
            .trigger("click");
        closePopup();
    };

    const loadMoreWines = () => {
        const products = jQuery(".c7-product:not(.display)");
        products.map(function (index) {
            if (index < 8) jQuery(this).addClass("display");
        });

        const count = jQuery(".c7-product.display").length;
        const total = jQuery(".c7-product").length;

        jQuery(selectors.count).html(`${count}`);
        jQuery(selectors.total).html(`${total}`);

        if (total) {
            jQuery(".info-container").show();
        }

        if (total <= count) {
            jQuery(selectors.loadmore).hide();
        } else {
            jQuery(selectors.loadmore).show();
        }
    };

    const loadCallout = () => {
        var collection = ''
        const path = window.location.pathname
        const match = path.match(/[^/]+(?=\/?$)/);
        const slug = match && match.length > 0 ? match[0] : null;
        if (slug != 'shop') {
            collection = slug
        } else {
            collection = jQuery(".filter-shop li").first().data("collection")
        }
        const products = jQuery(".c7-product");
        const shop_callouts = jQuery(".shop-callouts .callout");
        if (products.length) {
            shop_callouts.each(function (index) {
                const collectionData = jQuery(this).data("collection")
                const html = jQuery(this).clone();
                html.find('img.lazyloading').removeClass('lazyloading').addClass('lazyloaded');
                const seq = jQuery(this).data("seq")
                collectionData.forEach(function (item) {
                    if (item.value == collection) {
                        if (products.length >= seq) {
                            if (seq == 1) {
                                jQuery(html).insertBefore(
                                    `.c7-product-collection__product-list >div:nth-child(${seq})`
                                );
                            } else {
                                jQuery(html).insertAfter(
                                    `.c7-product-collection__product-list >div:nth-child(${seq - 1})`
                                );
                            }
                        } else {
                            jQuery(html).appendTo(".c7-product-collection__product-list");
                        }
                    }
                })
            })
        }
        jQuery(".shop-callouts .callout").each(function () {
            const collectionData = jQuery(this).data("collection")
            var element = jQuery(this)
            var show = false
            collectionData.forEach(function (item) {
                if (item.value == collection) {
                    show = true
                }
            })
            if (show) {
                element.show()
            } else {
                element.hide()
            }
        })
    };
}
